import {EventEmitter, Injectable, Injector} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  UnderlyingAssetsModalComponent, UnderlyingAssetsModalProps
} from './underlying-assets-modal.component';
import {createModalInjector} from "../../../../utils/create-modal-injector";

@Injectable()
export class UnderlyingAssetsModalService {
  constructor(private ngbModal: NgbModal, private injector: Injector) {}

  openDialog(props?: Partial<UnderlyingAssetsModalProps>): Promise<any> {
    const modalRef = this.ngbModal.open(UnderlyingAssetsModalComponent, {
      size: '80vw',
      centered: true,
      backdrop: 'static',
      injector: createModalInjector<Partial<UnderlyingAssetsModalProps>>(props, this.injector)
    });
    return modalRef.result;
  }

  get activeInstances(): EventEmitter<NgbModalRef[]> {
    return this.ngbModal.activeInstances;
  }
}
